import { ContentType } from '@standardnotes/snjs';
export function isSearchResultExistingTag(result, searchQuery) {
    return result.content_type === ContentType.TYPES.Tag && result.title === searchQuery;
}
